import { Button } from "@/components/ui/button";
import { getFullAddress } from "@/helper/format-data";
import { urbanFeatureValue } from "@/modules/urban-feature/urban-feature.const";
import { UrbanFeature } from "@/modules/urban-feature/urban-feature.types";
import useToggle from "hooks/use-toggle";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export type UrbanFeatureDetailProps = {
  urbanFeature: UrbanFeature;
  setUrbanFeatureModalState: () => void;
  removeUrbanFeature: () => void;
  onClose: () => void;
};
export const UrbanFeatureDetail = ({
  urbanFeature,
  setUrbanFeatureModalState,
  removeUrbanFeature,
  onClose,
}: UrbanFeatureDetailProps) => {
  const [openConfirm, setOpenConfirm] = useToggle(false);

  const handleOpenConfirm = () => {
    setOpenConfirm();
  };

  const handleClose = () => {
    onClose();
  };
  const address = getFullAddress(urbanFeature.address);
  return (
    <>
      <div className="transition-opacity absolute h-auto top-22 bg-primary p-3 right-6 mt-4 mb-3 rounded-md shadow-lg z-5 w-80">
        <div>
          <div className="flex justify-between w-full items-center py-2 gap-2">
            <span className="text-sm text-secondary">Name</span>
            <span className="text-sm text-secondary">{urbanFeature.name}</span>
          </div>
          <div className="flex justify-between w-full items-center py-2 gap-2">
            <span className="text-sm text-secondary">Address</span>
            <span className="text-sm text-secondary">{address}</span>
          </div>
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">Type</span>
            <span className="text-sm text-secondary">{urbanFeatureValue[urbanFeature.type]}</span>
          </div>
        </div>
        <div className="flex justify-between mt-4">
          <Button onClick={handleOpenConfirm} variant="destructive">
            Delete
          </Button>
          <Button onClick={setUrbanFeatureModalState} variant="secondary">
            Edit
          </Button>
          <Button onClick={handleClose} variant="secondary">
            Close
          </Button>
        </div>
      </div>
      <AlertDialog open={openConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete urban feature</AlertDialogTitle>
            <AlertDialogDescription>Are you sure that you want to delete this urban feature?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleOpenConfirm}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={removeUrbanFeature}>Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
